import { isNullOrUndefined } from "../../../services/Validator";
import CoursesSubthemesContent from "./CoursesSubthemesContent";
import {
    GradePickerSize
} from "../../../controllers/flashScreens/parameterStepScreen/ParameterGradeBadgeItemController";
import CoursesGradesList from "../../lists/courses/CoursesGradesList";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";
import SystemAppContentError from "../../errors/SystemAppContentError";

export default function CoursesCoreContent({ isGradesLoading,
                                             grades,
                                             gradesError,
                                             getFlashGrades,
                                             selectedGrade,
                                             setFlashGrade,
                                             isSubthemesLoading,
                                             subthemesError,
                                             subthemes,
                                             selectSubtheme,
                                             selectedSubtheme,
                                             levelAs,
                                             selectedLevelAs,
                                             pickLevelA,
                                             clearLevelAs }) {
    // Used in CoursesScreen to display both
    // Grade and Subthemes pickers

    // BUILD
    if (!isNullOrUndefined(gradesError))
        return <SystemAppContentError error={gradesError}
                                      isLoading={isGradesLoading}
                                      retryCallback={() => getFlashGrades()} />
    if (isGradesLoading)
        return <SystemAppContentLoader />
    return (
        <div className={"overflow-auto mt-[24px] w-full grow flex flex-col"}>
            <CoursesGradesList grades={grades}
                               selectedGrade={selectedGrade}
                               setFlashGrade={setFlashGrade}
                               gradePickerSize={GradePickerSize.MEDIUM} />
            <CoursesSubthemesContent selectedGrade={selectedGrade}
                                     isSubthemesLoading={isSubthemesLoading}
                                     subthemesError={subthemesError}
                                     subthemes={subthemes}
                                     selectSubtheme={selectSubtheme}
                                     selectedSubtheme={selectedSubtheme}
                                     levelAs={levelAs}
                                     pickLevelA={pickLevelA}
                                     clearLevelAs={clearLevelAs}
                                     selectedLevelAs={selectedLevelAs} />
        </div>
    );
}